export default {
  shared: {
    hooks: {
      useSearchParams: {
        name: "Ism bo'yicha",
        passport: "Pasport bo'yicha",
        phone: "Telefon bo'yicha",
        pinfl: "PINFL bo'yicha",
        clientId: "Mijoz ID bo'yicha",
        applicationId: "Ariza ID bo'yicha",
      },
      useModuleOptions: {
        module_acquiring: 'Ekvayring & BML',
        module_alifshop: 'Alif Shop',
        module_azo: 'Alif Nasiya',
        module_admin: 'Admin sahifa',
      },
    },
  },
};
